import React, { useEffect, useMemo } from "react";

import Chart from "react-apexcharts";




import { useSelector } from "react-redux";

import { usePost } from "../../../api/reactQueryCustomHooks";

import { apiRoute } from "../../../constants/enum";

import {
  createAnalytics
} from "./Analytics";


import {
  lineChart,
  barHorizontal,
  barVertical,
  pieChart,
  treemapChart,
  repeatOrderChart,
  barHorizontalMultiColor,
  polarChart
} from "./ChartConfig";


import "./Dashboard.css";




function Temp() {


  const { compCode } = useSelector(
    state => state.company
  );


  const {
    data: salesData = [],
    mutate: loadData
  } = usePost({

    url: apiRoute.dashboard.getMultiYearSaleData,

    queryKey: "DashboardSale"

  });





  useEffect(() => {


    loadData({

      data: {

        compcode: compCode.join(","),

        action: "OVERALL SUMMARY",

        db_inilchar: "ACC",

        fromdate: "2026-04-01",

        todate: "2027-03-31",

        lacid: ""

      }

    });


  }, []);






  const analytics =
    useMemo(
      () => createAnalytics(salesData),
      [salesData]
    );



  const {


    totalSales,

    totalQty,

    customers,

    products,

    avgRate,

    monthData,

    categoryData,

    partyData,

    itemData,

    bestFabric,

    slowFabric,

    repeatOrders,

    rateTrend


  } = analytics;


const repeatSeries=[

{
name:"Repeat Orders",

data:
repeatOrders.map(x=>x[1])

}

];

console.log("Best Fabric",repeatOrders);




  /****************
   CHARTS
  ****************/



  const salesSeries = [

    {

      name: "Sales",

      data:
        monthData.map(x => x.sales)

    }

  ];



  const qtySeries = [

    {

      name: "Quantity",

      data:
        monthData.map(x => x.qty)

    }

  ];





  const categorySeries =
    categoryData.map(
      x => x[1]
    );





  const partySeries = [

    {

      name: "Revenue",

      data:
        partyData.map(x => x[1])

    }

  ];





  const itemSeries = [

    {

      name: "Sales",

      data:
        itemData.map(x => x[1])

    }

  ];







  const bestFabricSeries = [

    {

      name: "Quantity",

      data:
        bestFabric.map(x => x[1])

    }

  ];





  const slowFabricSeries = [

    {

      name: "Quantity",

      data:
        slowFabric.map(x => x[1])

    }

  ];






  const rateSeries = [

    {

      name: "Rate",

      data:
        rateTrend.map(x => x.rate)

    }

  ];






  /***************
   FORECAST
  ****************/


  let forecast =
    [...monthData];


  if (monthData.length > 2) {


    let avgGrowth = 0;


    for (
      let i = 1;
      i < monthData.length;
      i++
    ) {

      avgGrowth +=

        monthData[i].sales
        -
        monthData[i - 1].sales;


    }



    avgGrowth =
      avgGrowth /
      (monthData.length - 1);



    forecast.push({

      month: "Forecast",

      sales:
        monthData.at(-1).sales
        +
        avgGrowth

    });


  }




  const forecastSeries = [

    {

      name: "Sales",

      data:
        forecast.map(x => x.sales)

    }

  ];








  return (

    <div className="dashboard">



      <h1>
        Textile Sales Intelligence Dashboard
      </h1>





      <div className="cards">



        <Card

          //icon={<DollarSign/>}

          title="Total Revenue"

          value={
            "₹ " + totalSales.toLocaleString()
          }

        />



        <Card

          //icon={<Package/>}

          title="Total Quantity"

          value={
            totalQty.toLocaleString()
          }

        />



        <Card

          //icon={<Users/>}

          title="Customers"

          value={customers}

        />



        <Card

          //icon={<Layers/>}

          title="Fabric Types"

          value={products}

        />



        <Card

          //icon={<TrendingUp/>}

          title="Average Rate"

          value={
            avgRate.toFixed(2)
          }

        />



      </div>








      <div className="box">


        <h2>
          Monthly Sales Trend
        </h2>


        <Chart

          options={
            lineChart(monthData)
          }

          series={
            salesSeries
          }

          type="line"

          height={350}

        />


      </div>









      <div className="grid">



        <div className="box">


          <h2>
            Quantity Trend
          </h2>


          <Chart

            options={
              lineChart(monthData)
            }

            series={
              qtySeries
            }

            type="area"

            height={300}

          />



        </div>







        <div className="box">


          <h2>
            Cloth / Yarn Revenue
          </h2>



          <Chart


            options={
              pieChart(categoryData)
            }


            series={
              categorySeries
            }


            type="donut"


            height={300}

          />


        </div>



      </div>









   








     <div className="grid">


<div className="box">

<h2>
🔥 Top Selling Fabric
</h2>


<Chart

options={treemapChart(itemData)}

series={[
{
data:itemData.map(x=>({
x:x[0],
y:x[1]
}))
}
]}

type="treemap"

height={380}

/>


</div>




<div className="box">

<h2>
💰 High Revenue Customer
</h2>


{/* <Chart

options={barHorizontal(partyData)}

series={partySeries}

type="bar"

height={380}

/> */}

<Chart

options={barHorizontalMultiColor(partyData)}

series={[
{
    name:"Revenue",
    data:partyData.map(x=>x[1])
}
]}

type="bar"

height={450}

/>


</div>



</div>









      <div className="grid">



        <div className="box">


          <h2>
            🔥 Best Selling Fabric
          </h2>



        <Chart

options={barHorizontal(bestFabric)}

series={[
{
name:"Revenue",
data:bestFabric.map(x=>x.value)
}
]}

type="bar"

height={400}

/>


        </div>










        <div className="box">


          <h2>
            🐢 Slow Moving Fabric
          </h2>


          {/* <Chart


            options={
              barHorizontal(slowFabric)
            }


            series={
              slowFabricSeries
            }


            type="bar"


            height={400}


          /> */}

<Chart

options={barHorizontal(slowFabric)}

series={[
{
name:"Revenue",
data:slowFabric.map(x=>x.value)
}
]}

type="bar"

height={400}

/>

        </div>




      </div>







<div className="grid">

      <div className="box">


        <h2>
          📈 Rate Increase / Decrease Signal
        </h2>



        <Chart


          options={
            lineChart(rateTrend)
          }


          series={
            rateSeries
          }


          type="line"


          height={350}


        />


      </div>









      <div className="box">


        <h2>
          🔮 Future Sales Pattern
        </h2>



        <Chart


          options={

            lineChart(forecast)

          }


          series={

            forecastSeries

          }


          type="line"


          height={350}


        />


      </div>



</div>





      <div className="box">


        <h2>
          🔁 Repeat Order Pattern
        </h2>


<Chart

    options={
        repeatOrderChart(repeatOrders)
    }


    series={
        repeatOrders.map(
            x => x.orders
        )
    }


    type="polarArea"


    height={450}

/>


      </div>








    </div>

  )


}









function Card({
  title,
  value,
  icon
}) {


  return (

    <div className="card">


      <div className="card-icon">

        {icon}

      </div>


      <h3>
        {title}
      </h3>


      <h2>
        {value}
      </h2>



    </div>


  )

}



export default Temp